/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UploadType = {
    Rrp: 'Rrp',
    Cost: 'Cost',
    ValueBasedPrice: 'ValueBasedPrice'
} as const;
export type UploadType = typeof UploadType[keyof typeof UploadType];


export function instanceOfUploadType(value: any): boolean {
    for (const key in UploadType) {
        if (Object.prototype.hasOwnProperty.call(UploadType, key)) {
            if (UploadType[key as keyof typeof UploadType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UploadTypeFromJSON(json: any): UploadType {
    return UploadTypeFromJSONTyped(json, false);
}

export function UploadTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadType {
    return json as UploadType;
}

export function UploadTypeToJSON(value?: UploadType | null): any {
    return value as any;
}

export function UploadTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): UploadType {
    return value as UploadType;
}

